<template>
  <f7-button
    v-if="item"
    :title="t(`${item.title}`)"
    class="navigation-bar__item"
    @click="emitItemClicked(item)"
  >
    <div>
      <img
        v-if="item.icon"
        :src="item.icon"
        :width="item.width"
        :height="item.height"
        class="navigation-bar__item-icon"
        :class="{
          'navigation-bar__icon-width': !item.width,
          'navigation-bar__icon-height': !item.height,
        }"
      >

      <div
        v-else
        class="navigation-bar__default-icon"
      />
    </div>
  </f7-button>
</template>

<script setup>
// @ts-check
import { useI18n } from 'vue-i18n';

/** @import { PropType } from 'vue' */
/** @import { SideNavbarItem } from '@/composables/useSideNavbar' */

defineProps({
  item: {
    /** @type {PropType<SideNavbarItem>} */
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['itemClicked']);

const { t } = useI18n();

/**
 * Emits a click event for the item.
 * @param {SideNavbarItem} item - The item that was clicked.
 */
function emitItemClicked(item) {
  emit('itemClicked', item);
}
</script>

<style scoped lang="scss">
.navigation-bar__item {
  --f7-button-bg-color: transparent;

  width: 100%;
  padding: var(--f7-typography-padding);
  cursor: pointer;
}

.navigation-bar__item-icon {
  display: flex;
  align-items: center;
}

.navigation-bar__icon-width {
  width: 26.3px;
}

.navigation-bar__icon-height {
  height: 36.5px;
}

.navigation-bar__default-icon {
  width: 10px;
  height: 10px;
  background-color: var(--his-dark-blue);
}
</style>
